import React from 'react';
import { Container } from './styles';
import { Title, Icon } from '@gerdau/hefesto';

const Success: React.FC = () => {
  return (
    <Container>
      <Icon option="CheckCircle2" variant="tertiary" size="full" />
      <Title level={3}>Resgate Confirmado</Title>
      <p className="subtitle">
        Seu pedido de resgate foi enviado, uma confirmação será enviada ao seu
        email
      </p>
    </Container>
  );
};

export default Success;
